import { render, staticRenderFns } from "./mobileTabView.vue?vue&type=template&id=4b891bd2&scoped=true"
import script from "./mobileTabView.vue?vue&type=script&lang=js"
export * from "./mobileTabView.vue?vue&type=script&lang=js"
import style0 from "./mobileTabView.vue?vue&type=style&index=0&id=4b891bd2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_ec1e824a4fe600ca080e24d3f05cd390/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b891bd2",
  null
  
)

export default component.exports